import { render } from "./App.vue?vue&type=template&id=64c0c416"
const script = {}

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/suivi-live/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__